var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',{staticClass:"subpage"},[_c(_setup.PageSubHeader,{attrs:{"title":_vm.title,"subtitle":_vm.subtitle,"title-tag":"h2"},scopedSlots:_vm._u([{key:"header",fn:function(){return [_vm._t("header")]},proxy:true}],null,true)}),_c(_setup.SmeCard,_vm._b({},'sme-card',_vm.$attrs,false),[_vm._t("default")],2)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }